let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("14AfH")).then(() => parcelRequire('18WIw'));